module.exports = __webpack_public_path__ + "static/media/img.63252149.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/img.JPG
// module id = 86
// module chunks = 0